import { User } from 'src/app/interfaces/user';

export const USER_LIDER: User = {
  userId: 1,
  username: 'supervisor',
  firstname: 'Usuario',
  lastname: 'Lider',
  email: '',
  enabled: true,
  roles: [
    {
      roleId: 1,
      roleName: 'Supervisor',
      managementUnit: {
        managementUnitId: 1,
        managementUnitName: 'NQN',
      },
      permissions: [
        {
          permissionId: 1,
          permissionName: 'Crear HO',
        },
        {
          permissionId: 2,
          permissionName: 'Editar HO',
        },
        {
          permissionId: 3,
          permissionName: 'Enviar HO',
        },
        {
          permissionId: 4,
          permissionName: 'Aprobar HO',
        },
        {
          permissionId: 5,
          permissionName: 'Tomar HO',
        },
        {
          permissionId: 6,
          permissionName: 'Eliminar Borrador HO',
        },
        {
          permissionId: 7,
          permissionName: 'Liberar HO',
        },
        {
          permissionId: 8,
          permissionName: 'Visualizar Emitidos HO',
        },
        {
          permissionId: 9,
          permissionName: 'Visualizar Recibidos HO',
        },
        {
          permissionId: 10,
          permissionName: 'Buscar Pozo',
        },
        {
          permissionId: 11,
          permissionName: 'Visualizar Historico HO',
        },
        {
          permissionId: 12,
          permissionName: 'Visualizar HO Equipo',
        },
        {
          permissionId: 13,
          permissionName: 'Eliminar Rechazo HO',
        },
      ],
    },
  ],
};

export const USER_CONSULTA: User = {
  userId: 2,
  username: 'userConsulta',
  firstname: 'Usuario',
  lastname: 'Consulta',
  email: '',
  enabled: true,
  roles: [
    {
      roleId: 5,
      roleName: 'Consulta',
      managementUnit: {
        managementUnitId: 1,
        managementUnitName: 'NQN',
      },
      permissions: [
        {
          permissionId: 10,
          permissionName: 'Buscar Pozo',
        },
        {
          permissionId: 11,
          permissionName: 'Visualizar Historico HO',
        },
      ],
    },
  ],
};
